import { date as dayjs } from '../plugins/date'
export const INVALID_DATE = 'Invalid Date'

export const dateFormats = {
  date: 'YYYY-MM-DD',
  dateTime: 'YYYY-MM-DD HH:mm',
  time: 'HH:mm',
  dateRu: 'DD.MM.YYYY'
}

export const dateReadableFormats = {
  date: 'DD.MM.YYYY г.',
  dateTime: 'DD.MM.YYYY г. HH:mm ч.',
  time: 'HH:mm'
}

export const DATE_REGEX = /^\d{2}\.\d{2}\.\d{4}$/

export const dateFormat = (date, format = dateReadableFormats.date, subtractTimezone = true, timezone, itsTimezoneLocalTime = false) => {
  if (!date) return
  const parseFormat = (typeof date === 'string') && DATE_REGEX.test(date)
    ? dateFormats.dateRu
    : undefined

  let innerDate = dayjs(date, parseFormat)
  if (timezone) {
    innerDate = innerDate.tz(timezone, itsTimezoneLocalTime)
  }
  if (subtractTimezone) {
    innerDate = innerDate.utc()
  }
  // пустой format() возвращает в формате iso YYYY-MM-DDTHH:mm:ssZ
  const formatDate = innerDate.format(format)
  return formatDate === INVALID_DATE ? null : formatDate
}
